function Support() {
  return (

    <div className="support">
      <div className="sup-flex">
        <div className='sup-text'>
          <h1>جاهز تبدأ رحلتك العقاريه ؟</h1>
          <div style={{ marginBottom: '20px' }}>
            <button >أشترك</button>
            <input type="email" name="" id="" placeholder='البريد الاكتروني ' />
          </div>
          <span>نسمعك بعنايه , وتوصل لاختيار الافضل </span>
        </div>
        <img src="/hero-rigth.png" alt="hero-image" className='hero-img' />
      </div>
    </div>
  );
}
export default Support;